<script>
    import { Bar } from 'vue-chartjs'
    import http from "@state/http";
    import store from "../../../../state/store";

    export default {
        extends: Bar,
        data() {
            return {
                A: [],
                B: [],
                pkgs: []
            };
        },
        mounted() {
            this.housePackageChart();
        },
        methods: {
            housePackageChart(){
                http.post("api/ses/land/house/report/package")
                    .then(response => {
                        let res = response.data;
                        
                        for(var i = 0; i < res.houses.length; i++){
                            this.A.push(res.houses[i].A)
                            this.B.push(res.houses[i].B)
                        }

                        for(var i = 0; i < res.houses.length; i++){

                            for(var j = 0; j < res.pkgs.length; j++){
                               if(res.pkgs[j].id == res.houses[i].package_id){
                                   this.pkgs.push(res.pkgs[j].desc)
                                    // console.log(res.pkgs[j])

                               }
                            }
                        }

                        this.renderChart(
                            {
                                labels: this.pkgs,
                                datasets: [
                                    {
                                        label: 'A',
                                        backgroundColor: '#1abc9c',
                                        borderColor: '#1abc9c',
                                        hoverBackgroundColor: '#1abc9c',
                                        hoverBorderColor: '#1abc9c',
                                        data: this.A,
                                    },
                                    {
                                        label: 'B',
                                        backgroundColor: '#311BFE',
                                        borderColor: '#311BFE',
                                        hoverBackgroundColor: '#311BFE',
                                        hoverBorderColor: '#311BFE',
                                        data: this.B,
                                    },
                                ],
                            },
                            {
                                responsive: true,
                                maintainAspectRatio: true,
                                legend: {
                                    display: true,
                                },
                                
                                scales: {
                                    yAxes: [
                                        {
                                            gridLines: {
                                                display: true,
                                            },
                                            stacked: false,
                                            ticks: {
                                                // stepSize: 1,
                                                min: 0,
                                                max: 300, // The response got from the ajax request containing max limit for y axis
                                                maxTicksLimit: 15
                                            },
                                        },
                                    ],
                                    xAxes: [
                                        {
                                            barPercentage: 0.7,
                                            categoryPercentage: 0.5,
                                            stacked: false,
                                           
                                            gridLines: {
                                                color: 'rgba(0,0,0,0.01)',
                                            },
                                        },
                                    ],

                                },
                            }
                        )
                    })

                    
            }
            
        },
    }
</script>